module.exports = __webpack_public_path__ + "img/location-pin-single.c772d600.svg";